<ph-dialog [open]="open" size="sm" [heading]="title" [noClose]="locked" (ph-close)="onDismiss()">
    <ng-container *ngIf="open">
        <app-sms-auth-setup-step #step
            (completed)="onCompleted()"
            (showingRecoveryCodes)="onShowingRecoveryCodes()"
            (cancelled)="onCancelled()"></app-sms-auth-setup-step>
        <ng-container *ngTemplateOutlet="step.footer"></ng-container>
    </ng-container>
</ph-dialog>
